import axios from "axios";

export function getInit() {
    return axios.get("/api/account/init" );
}

export function exitInitStepTutorial() {
    return axios.get("/api/account/exitInitStepTutorial");
}
